export default __webpack_public_path__ + "034ceb7b0a143ea47567faadf1104338.jpg";